module.exports = __webpack_public_path__ + "static/media/Q2.07c223ba.png";